import { render, staticRenderFns } from "./WasteCollection.vue?vue&type=template&id=3f6e106e"
import script from "./WasteCollection.vue?vue&type=script&lang=js"
export * from "./WasteCollection.vue?vue&type=script&lang=js"
import style0 from "./WasteCollection.vue?vue&type=style&index=0&id=3f6e106e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports